// Pure rules for the community list's background refresh (no browser or app
// imports, so they are unit-testable).

/**
 * A refresh is due only while the tab is visible (a hidden tab displays
 * nothing, and each refresh costs one community fetch plus one enrichment
 * request per member on a small shared API instance), when no refresh is
 * already running, once the last load is at least intervalMs old, and while
 * the user has been active within idleLimitMs. Without that last rule a tab
 * left open and visible would poll all day for nobody. An unknown
 * lastActivityAt counts as active.
 */
export const isCommunityRefreshDue = ({
    now,
    lastLoadedAt,
    lastActivityAt,
    visible,
    inFlight,
    intervalMs,
    idleLimitMs,
}) => {
    if (!visible || inFlight) return false
    if (
        Number.isFinite(lastActivityAt) &&
        Number.isFinite(idleLimitMs) &&
        now - lastActivityAt > idleLimitMs
    ) {
        return false
    }
    if (!Number.isFinite(lastLoadedAt)) return true
    const ageMs = now - lastLoadedAt
    // A clock that moved backwards should not freeze the poll.
    if (ageMs < 0) return true
    return ageMs >= intervalMs
}
